<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#1e2132"
          text-color="#fff" active-text-color="#409EFF">
          <el-menu-item :index="item.caId" v-for="(item, index) in catalogs" :key="index"
            @click="_changeMenuCatalog(item, true)" :id="item.caId">{{ item.name }}</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">

        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-if="badge" style="position: relative;width: 55px;cursor: pointer;" @click="toUndo()">
          <el-badge :value="badge" class="item">
            <i class="fa fa-bell-o margin-right-xs"></i>
          </el-badge>
        </div>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <!-- <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                  @click="switchMenu(menu)">
                  <i class="fa " v-bind:class="menu.icon"></i><span class="margin-left-xs">{{ menu.name }}</span>
                </li>
              </template>
</ul>
</div>
<div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
  <ul>
    <li class="title">{{ curMenuName }}</li>
    <template v-for="(subMenu, index) in subMenus">
                <li :key="index" v-if="subMenu.isShow == 'Y'" :class="{ active: subMenu.active }"
                  v-on:click="_gotoPage(subMenu.href, subMenu.name)">
                  {{ subMenu.name }}
                </li>
              </template>
    <li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
  </ul>
</div>
</div>
</el-aside> -->

      <div class="vc-menu  flex justify-start" id="menu-nav" v-if="menus && menus.length > 0&&$route.path!='/ioc/index'">
        <div class="vc-menu-main">
          <ul>
            <li v-for="menu in menus" :key="menu.id" :class="{ active: menu.active }"  v-if="menu.childs != undefined && menu.childs.length > 0">
                <div class="menu-item flex justify-start align-center" @click="openMenu(menu)">
                  <i class="fa " :class="menu.icon"></i>
                  <span class="menu-item-name">{{ menu.name }}</span>
                  <i class="fa fa-angle-down icon-angle"
                    v-if="!menu.opened && menu.childs != undefined && menu.childs.length > 0"></i>
                  <i class="fa fa-angle-up icon-angle"
                    v-if="menu.opened && menu.childs != undefined && menu.childs.length > 0"></i>
                </div>
                <div class="submenu" v-show="!!menu.opened">
                  <div class="submenu-item" :key="subMenu.id" v-for="subMenu in menu.childs" v-if="subMenu.isShow == 'Y'"
                    :class="{ active: subMenu.active }" @click="_gotoPage(subMenu.href, subMenu.name)">
                      <i class="fa " :class="subMenu.icon"></i>
                      <span class="margin-left-xs">{{ subMenu.name }}</span>
                  </div>
                </div>
            </li>

          </ul>
        </div>
      </div>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'
import { daHuaICCToken } from '@/api/ioc/index'
import { getUndoInfo } from '@/api/oa/newOaWorkflowDoingApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'Layout',
  data() {
    return {
      badge: 0,
      isOnLach: true,
      menus: [],
      catalogs: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      communityId: getCommunityId()
    }
  },
  created() {
    
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
    getUndoInfo(
      {
      communityId: this.communityId,
      page: 1,
      row: 10
    }
    ).then(res => {
      if (res.code === 0) {
        this.badge = res.data.undoCount
        let total = 0;
        const keys = ['repair', 'complaint', 'purchase', 'collection', 'contractApply', 'contractChange', 'allocation', 'itemReleaseCount', 'visitUndoCount'];
        keys.forEach(key => {
            total += Number(res.data[key]||0);
        });
        this.badge = total;
        if (this.badge > 99) {
            this.badge = '99+';
        }
      }
    })
  },
  mounted() {
    if (this.$route.path == '/ioc/alaramManage/handleAlarm') {
      this.$nextTick(() => {
        // setTimeout(() => {
          const btn = document.getElementById('102025120395890463')
          console.log(btn)
          if (btn) {
            btn.click()
          }
        // }, 3000);
      })
    }
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    toUndo() {
      const info = this.catalogs.find(item => item.name === '业主服务');
      if (info) {
          this._changeMenuCatalog(info)
      }
      this.$router.push({ path: '/pages/property/newOaWorkflowDoing' })
    },
    setMenus(_menus) {
      window.localStorage.setItem('hc_menus', JSON.stringify(_menus));
    },
    openMenu(_menu) {
      //设置菜单ID
      this.menus.forEach(item => {
        if (item.id != _menu.id) {
          item.opened = false;
        } else {
          item.opened = !_menu.opened;
        }
      });
      this.setMenus(this.menus);
      this.$forceUpdate();
    },
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        this.catalogs = res.data;
        console.log('this.catalogs')
        console.log(this.catalogs)
        if (this.catalogs && this.catalogs.length > 0) {
          // let menuId = window.localStorage.getItem('hc_menuId')
          // if (menuId)this.menuId = menuId
          console.log('this.menuId')
          console.log(this.menuId)
          let caId = window.localStorage.getItem('caId')
          if (caId) {
            let obj = this.catalogs.filter(item => item.caId == caId)
            console.log('obj')
            console.log(obj)
            if (obj)this._changeMenuCatalog(obj[0])
            else this._changeMenuCatalog(this.catalogs[0])
          } else {
            this._changeMenuCatalog(this.catalogs[0])
          }
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      localStorage.setItem('caId', _catalog.caId)
      console.log('_changeMenuCatalog', _catalog)
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == '/#/screen') {
        window.open('/#/screen', '_blank');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
      // if (localStorage.getItem('hc_menus')){
      //   let list = JSON.parse(localStorage.getItem('hc_menus'))
      //   if (list.length == 0) {
      //     this.loadMenuTree(_catalog)
      //     return
      //   }
      //   this.menuTree = list;
      //   this.menus = list
      //   this._setSelectedMenusChild('/#'+this.$route.fullPath)
      // } else {
      //   this.loadMenuTree(_catalog)
      // } 
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
     setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      // window.location.href = "/"
      window.location.reload()
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      console.log('loadMenuTree', _catalog)
      getMenuTree(_catalog).then(res => {
        let _menus = res.data||[]
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        _menus = _menus.filter(item => item.childs && item.childs.some(c => c.isShow == 'Y'))
        _menus.forEach(item => {
          item.childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
        })
        this.menus = _menus

        if (_menus == null || _menus.length == 0) {
          this.menus = [];
          this.setMenus(this.menus);
          return;
        }
        // this.menus = this.refreshMenuActive(_menus, '');
        // this.setMenus(this.menus);
        // if (_catalog.isInit) {
        //   // 初始化
          for (var menuIndex = 0; menuIndex < this.menus.length; menuIndex++) {
            if (this.menus[menuIndex].childs && this.menus[menuIndex].childs.length > 0) {
              var _childs = this.menus[menuIndex].childs;
              for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
                const menuInfo = _childs[childIndex]
                const currentUrl = window.location.href
                if (currentUrl.indexOf(menuInfo.href) > -1) {
                  console.log('currentUrl.indexOf(menuInfo.href) > -1')
                  this.switchMenu(this.menus[menuIndex], childIndex);
                  this.openMenu(this.menus[menuIndex], childIndex);
                  menuInfo.active = true
                  return;
                }
              }
            }
          }
          if (this.$route.path == '/ioc/alaramManage/handleAlarm'&&this.$route.query.caId) {
            this.$nextTick(() => {
                const btn = document.getElementById('102025120395890463')
                if (btn) {
                  btn.click()
                }
            })
          }
        //   this.switchMenu(_menus[0], -1);
        //   return
        // }
        // this.switchMenu(_menus[0]);
        // this.openMenu(_menus[0])
      })
    },
    switchMenu(_menu) {
      console.log('_menu')
      console.log(_menu)
      if (!_menu) {
        this.menuId = ''
        this.menus = []
        this.menuTree = []
        this.subMenus = []
        return
      }
      //设置菜单ID
      this.menuId = _menu.id;
      window.localStorage.setItem('hc_menuId', this.menuId);
      this.menus = this.refreshMenuActive(this.menus, _menu.id);
      this.subMenus = _menu.childs;
      // this.setMenus(this.menus);
      console.log(this.subMenus)
      this.curMenuName = _menu.name;

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      console.log(_menu.childs)
      console.log('选中第一个')
      // _menu.childs.forEach((item, index) => {
      //   if (item.href == window.location.href) {
      //     this._gotoPage(_menu.childs[index].href, _menu.childs[index].name)
      //     return;
      //   }
      // })
      //选中第一个
      // window.location.href
      // this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          // _childs.sort(function (_child, _newChild) {
          //   return _child.seq - _newChild.seq
          // });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menus.length; menuIndex++) {
        if (this.menus[menuIndex].childs) {
          var _childs = this.menus[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menus[menuIndex].childs[childIndex].active = true;
            } else {
              this.menus[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    async _gotoPage(_href, _tabName) {
      // /#/pages/property/feeConfigManage 费用项设置
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href);
      if (_href.indexOf('https://192.168.1.118/#/thirdAccess') > -1) { //大华
        window.open(`https://192.168.1.118`, '_blank')
        return
        // const res = await daHuaICCToken()
        // const token = res.data.access_token
        // const refresh_token = res.data.refresh_token
        // if (!token){
        //   return
        // }
        // let redirect = encodeURIComponent('https://192.168.1.118/#/home')
        // window.open(`https://192.168.1.118/#/thirdAccess?accessToken=${token}&refreshToken=${refresh_token}&redirect=${redirect}`, '_blank')
      } 
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('http') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex() {
      location.href = '/'
    },
    _closeSubMenu() {
      this.subMenus = []
      this.curMenuName = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #1e2132;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  cursor: pointer;
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 0px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132;
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #409EFF;
}

// .vc-menu {
//   border-right: 1px solid #EFEFF0;

//   .vc-menu-main {
//     background-color: #1F2339;
//     color: #838A9B;
//     text-align: center;
//     // width: 140px;
//     font-size: 14px;
//     height: calc(100vh - 60px);
//     overflow-x: hidden;
//     overflow-y: scroll;
//     scrollbar-width: none;

//     .active {
//       background-color: #3E77FC;
//       color: #FFFFFF;
//     }
//   }

//   .vc-menu-main::-webkit-scrollbar {
//     display: none;
//   }

//   ul {
//     padding-inline-start: 0px;
//     margin: 0;
//     padding: 0;
//   }

//   li {
//     margin: 0;
//     padding: 0;
//   }
// }

// .moreCommunity {
//   font-weight: 600;
//   color: #212529;
//   font-size: 12px;
// }

// .vc-menu-main ul li {
//   height: 45px;
//   line-height: 45px;
//   cursor: pointer;
//   list-style-type: none;
// }

// .vc-menu-main ul li:hover {
//   background-color: #3E77FC;
//   color: #FFFFFF;
// }

// .vc-menu-main ul li.title {
//   color: #FFFFFF;
//   height: 60px;
//   font-size: 24px;
//   line-height: 60px;
// }

// .vc-menu-main ul li.title a {
//   text-decoration: none;
//   cursor: pointer;
//   color: #FFFFFF;
// }

// .vc-menu-sub {
//   background-color: #FFFFFF;
//   color: #545761;
//   text-align: start;
//   width: 110px;
//   font-size: 14px;
//   height: calc(100vh - 60px);
//   overflow-x: hidden;
//   overflow-y: scroll;
//   scrollbar-width: none;
// }

// .vc-menu-sub::-webkit-scrollbar {
//   display: none;
// }

// .vc-menu-sub .active {
//   background-color: #EAF0FE;
//   color: #3E77FC;
// }



// .vc-menu-sub ul li {
//   height: 40px;
//   line-height: 40px;
//   padding-left: 15px;
//   cursor: pointer;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }

// .vc-menu-sub ul li.title {
//   color: #4F525C;
//   height: 40px;
//   font-size: 14px;
//   line-height: 40px;
//   text-align: center;
//   padding-left: 0px;
//   border-bottom: 1px solid #F2F2F3;
//   margin-bottom: 10px;
// }

// .vc-menu-sub ul li:hover {
//   background-color: #EAF0FE;
//   color: #3E77FC;
// }

// .vc-menu-sub ul li.sub-footer {
//   background-color: #F6F6F7;
//   text-align: center;
//   position: fixed;
//   bottom: 0;
//   width: 100px;
// }
.vc-menu-main {
    background-color: var(--vc-menu-main-bg);
    color: var(--vc-menu-main-font-color);
    text-align: center;
    font-size: 14px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
}

.vc-menu-main::-webkit-scrollbar {
    display: none;
}


.vc-menu-main ul li {
    width: 200px;
    text-align-last: left;
    color: #bfcbd9;
}
.vc-menu-main ul li.active .menu-item-name {
    color: #fff;
}

.vc-menu-main ul li.title {
    color: var(--vc-menu-main-title-font-color);
    height: 60px;
    font-size: 24px;
    line-height: 60px;
}

.vc-menu-main ul li.title a {
    text-decoration: none;
    cursor: pointer;
    color: var(--vc-menu-main-title-font-color);
}

.vc-menu-main ul li .menu-item{
    cursor: pointer;
    padding-left: 20px;
    padding-right: 40px;
    height: 50px;
    line-height: 50px;
    position: relative;
}
.vc-menu-main ul li .menu-item-name{
    margin-left: 16px;
}
.vc-menu-main ul li .menu-item .icon-angle{
    position: absolute;
    right: 20px;
}

.vc-menu-main ul li .submenu{
    background: #1f2d3d;
}
.vc-menu-main ul li .submenu-item{
    cursor: pointer;
    padding-left: 24px;
    height: 50px;
    line-height: 50px;
}
.vc-menu-main ul li .submenu-item:hover {
    background: #000;
}
.vc-menu-main ul li .submenu-item.active {
    color: #409eff;
}


.vc-menu-sub {
    background-color: var(--vc-menu-sub-bg);
    color: var(--vc-menu-sub-font-color);
    text-align: start;
    width: 110px;
    font-size: 14px;
    height: 95%;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
}

.vc-menu-sub::-webkit-scrollbar {
    display: none;
}

.vc-menu-sub .active {
    background-color: var(--vc-menu-sub-bg-active-color);
    color: var(--vc-menu-sub-active-font-color);
}

.vc-menu-sub ul li {
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.vc-menu-sub ul li.title {
    color: var(--vc-menu-sub-title-font-color);
    height: 40px;
    font-size: 10px;
    line-height: 40px;
    text-align: center;
    padding-left: 0px;
    border-bottom: 1px solid #F2F2F3;
    margin-bottom: 10px;
}

.vc-menu-sub ul li:hover {
    background-color: var(--vc-menu-sub-bg-active-color);
    color: var(--vc-menu-sub-active-font-color);
}

.vc-menu-sub ul li.sub-footer {
    background-color: var(--vc-menu-sub-footer);
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 160px;
}
.vc-menu-main {
    background-color: #1F2339;
    color: #838A9B;
    text-align: center;
    // width: 140px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;

    .active {
      // background-color: #3E77FC;
      color: #FFFFFF;
    }
  }

.menu-item{
  display: flex;
  align-items: center;
}
</style>